import { createStateContext } from "src/utils/StateContext";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface SurveyContextData {}

export const { Context: SurveyContext, Provider: SurveyContextProvider } =
  createStateContext<SurveyContextData>({});
